var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-app"},[_c('Header',{attrs:{"step":_vm.step},on:{"lastStep":function($event){_vm.step = $event}}}),_c('Main',{attrs:{"step":_vm.step},on:{"changeStep":function($event){_vm.step = $event}}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }